import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Form5.css";

const Form5= () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    localCab: "",
    acType: "",
    transportType: "",
    sightseeing: "",
    hiddenPlaces: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelect = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const validate = () => {
    let err = {};

    if (!formData.localCab.trim()) {
      err.localCab = "Please specify Yes or No";
    }

    if (!formData.acType) {
      err.acType = "Select AC or Non-AC";
    }

    if (!formData.transportType) {
      err.transportType = "Select Private or Shared";
    }

    if (!formData.sightseeing) {
      err.sightseeing = "Select sightseeing priority";
    }

    if (!formData.hiddenPlaces.trim()) {
      err.hiddenPlaces = "Enter your preferences";
    }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

    const handleSubmit = (e) => {
      e.preventDefault();

      const isValid = validate();

      if (isValid) {
        navigate("/form6");
      }
    };

  return (
    <div className="transport-main">
      <div className="left-section">
        <h1>Local Transport & Sightseeing</h1>
      </div>

      <div className="right-section">
        <form onSubmit={handleSubmit} className="transport-form">
          <label>Local Cab Required?</label>
          <input
            type="text"
            name="localCab"
            placeholder="Yes / No"
            value={formData.localCab}
            onChange={handleChange}
          />
          {errors.localCab && <p className="error">{errors.localCab}</p>}

          <label>AC / Non-AC</label>
          <div className="button-group">
            {["AC", "Non-AC"].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${formData.acType === item ? "active" : ""}`}
                onClick={() => handleSelect("acType", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.acType && <p className="error">{errors.acType}</p>}

          <label>Private / Shared</label>
          <div className="button-group">
            {["Private", "Shared"].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${formData.transportType === item ? "active" : ""}`}
                onClick={() => handleSelect("transportType", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.transportType && (
            <p className="error">{errors.transportType}</p>
          )}

          <label>Sightseeing Priority</label>
          <div className="button-group">
            {["Must-see", "Optional"].map((item) => (
              <button
                type="button"
                key={item}
                className={`select-btn ${formData.sightseeing === item ? "active" : ""}`}
                onClick={() => handleSelect("sightseeing", item)}
              >
                {item}
              </button>
            ))}
          </div>
          {errors.sightseeing && <p className="error">{errors.sightseeing}</p>}

          <label>Offbeat / Hidden places interest</label>
          <input
            type="text"
            name="hiddenPlaces"
            placeholder="Enter your preferences"
            value={formData.hiddenPlaces}
            onChange={handleChange}
          />
          {errors.hiddenPlaces && (
            <p className="error">{errors.hiddenPlaces}</p>
          )}

          <div className="navigation-buttons">
            <button
              type="button"
              className="back-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>

            <button type="submit" className="next-btn">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Form5;
